import BaseRepository from './BaseRepository';

class CurrentUserRepository extends BaseRepository {
  public getCurrentUser(): Promise<any> {
    return this.httpClient.get('/v2/users/current').then((res: any) => res.data.data);
  }
}

export default CurrentUserRepository;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/repository/CurrentUserRepository.ts